import React from 'react';
import Styles from '../popular_blog/Popular_blogs.module.css';
import Card from '@/components/general/Card';
import AppImage from '@/components/common/AppImage';
import ViewCount from '@/components/pages/home/HomeContent/SampleBlogs/BlogCard/ViewCount';
import AppLink from '@/components/common/AppLink';

function Popular_blogs({ popularBlog, index }) {
  console.log('popularBlog', popularBlog);
  console.log('blogObject.image.src', popularBlog?.fileImage?.name);
  return (
    <AppLink
      href={'/blogs/' + popularBlog?.slug}
      className={Styles.popular_blogs_a}
      title={popularBlog?.title}
      target={`_parent`}
    >
      <div className={Styles.popular_Posts}>
        <div className={`${Styles.cardNumber}`}>{index + 1}</div>
        <div className={Styles.popular_Posts_description}>
          <p className={Styles.main_description}>{popularBlog?.title}</p>
          <div className={Styles.blog_details}>
            <ViewCount count={popularBlog?.viewNum} />
          </div>
        </div>
      </div>
    </AppLink>
  );
}

export default Popular_blogs;
